/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiateInvestmentOrder} from '../api'

export const useMutationInitiateInvestmentOrder = createReactQueryMutationHook('initiateInvestmentOrder', initiateInvestmentOrder)
